import { render } from "./CandleFormStep4.vue?vue&type=template&id=31f961ee&scoped=true&lang=html"
import script from "./CandleFormStep4.vue?vue&type=script&lang=js"
export * from "./CandleFormStep4.vue?vue&type=script&lang=js"

import "./CandleFormStep4.vue?vue&type=style&index=0&id=31f961ee&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f961ee"]])

export default __exports__